var render, staticRenderFns
import script from "./ChartBarExample.vue?vue&type=script&lang=js&"
export * from "./ChartBarExample.vue?vue&type=script&lang=js&"
import style0 from "./ChartBarExample.vue?vue&type=style&index=0&id=784f86f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784f86f8",
  null
  
)

export default component.exports